// Translations for Yamauchi Ramen website

export const translations = {
  es: {
    // Header
    nav: {
      inicio: "Inicio",
      nosotros: "Nosotros",
      menu: "Menú",
      ubicacion: "Ubicación",
      galeria: "Galería",
      afiliados: "Afiliados",
      colaboradores: "Colaboradores"
    },
    
    // Hero
    hero: {
      subtitle: "El Espíritu del Ramen",
      title: "YAMAUCHI",
      mainTitle: "El mejor ramen",
      mainTitleHighlight: "de la montaña",
      description: "Inspirados en la gastronomía japonesa con su toque puertorriqueño.",
      descriptionHighlight: "Descubre el sabor y la frescura que solo se encuentra en la montaña.",
      explorarMenu: "Explorar Menú",
      verGaleria: "Ver Galería y Video",
      programaAfiliados: "Programa de Afiliados",
      colaboradores: "Colaboradores",
      eyebrow: "Menjin · El Espíritu del Ramen",
      verNovedades: "Ver Novedades",
      ordenar: "Ordenar",
      badge: "Artesanal · Desde 2024",
      stats: {
        oneValue: "100%",
        oneLabel: "Artesanal",
        twoValue: "Jue—Dom",
        twoLabel: "Abierto",
        threeValue: "Cayey,",
        threeLabel: "Puerto Rico"
      }
    },

    // Sections / Eyebrows
    sections: {
      pillarsEyebrow: "Filosofía",
      pillarsTitle: "Lo que nos hace únicos",
      pillarsSubtitle: "Tres pilares que definen cada bowl, cada copa y cada experiencia en Yamauchi.",
      trendingEyebrow: "Novedades",
      trendingTitlePre: "Lo que está ",
      trendingTitleHighlight: "trending",
      trendingDesc: "Descubre las creaciones que están conquistando a nuestra comunidad esta temporada.",
      communityEyebrow: "Comunidad",
      communityTitle: "Más que un restaurante",
      communitySubtitle: "Somos una comunidad que celebra la naturaleza, la cultura y el ramen de montaña."
    },

    // Community Actions
    community: {
      affiliateTitle: "Programa de Afiliados",
      affiliateDesc: "¿Eres creador de contenido y exploras las montañas de Puerto Rico? Únete a Menjin y recibe ramen gratis a cambio de tu contenido auténtico.",
      collabTitle: "Colaboradores",
      collabDesc: "Conoce a los artistas, productores y marcas que comparten nuestra visión de fusionar la cultura japonesa con el alma boricua.",
      galleryTitle: "Galería & Videos",
      galleryDesc: "Siente la experiencia Yamauchi antes de llegar. Fotos del lugar, el proceso artesanal y los mejores momentos de nuestra comunidad.",
      explore: "Explorar"
    },

    // Reviews invitation
    reviewsInvite: {
      text: "Aún estamos recopilando nuestras primeras reseñas en Google. Si ya nos visitaste, tu opinión nos ayuda a seguir creciendo."
    },

    aboutBtn: "Conocer Más",
    contactLabel: "Contacto",
    
    // Trending
    trending: {
      title: "Trending",
      subtitle: "Lo más popular en Yamauchi"
    },
    
    // About
    about: {
      title: "Nuestra Historia",
      subtitle: "Tradición japonesa en el corazón de Puerto Rico",
      features: {
        noodles: {
          title: "Fideos Caseros",
          description: "Preparados diariamente con técnicas tradicionales japonesas"
        },
        chicken: {
          title: "Pollo Sous Vide",
          description: "Cocción perfecta a baja temperatura para máximo sabor"
        },
        ingredients: {
          title: "Ingredientes Premium",
          description: "Seleccionados de las mejores fuentes locales y japonesas"
        }
      }
    },
    
    // Menu
    menu: {
      title: "Nuestro Menú",
      subtitle: "Descubre nuestros platos principales, creados con amor y las mejores técnicas japonesas",
      verMenu: "Ver Menú",
      expand: "Ver todo el menú",
      collapse: "Ver menos",
      todos: "Todos",
      menjinApproves: "¡Menjin aprueba cada plato con su sello de calidad!",
      categories: {
        ramen: "Ramen",
        ramenEspecialidad: "Ramen Especialidad",
        combos: "Combos",
        aperitivos: "Aperitivos",
        donburi: "Donburi",
        postre: "Postre",
        bebidas: "Bebidas"
      }
    },
    
    // Location
    location: {
      title: "Ubicación & Horarios",
      subtitle: "Visítanos en las hermosas montañas de Cayey, Puerto Rico",
      address: "Dirección",
      viewOnMaps: "Ver en Google Maps",
      hours: "Horarios",
      orderOnline: "Ordena Online",
      callDirect: "Llamar Directo",
      followUs: "Síguenos en Redes Sociales",
      shareExperience: "¡Comparte tu experiencia con #YamauchiRamen!",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo"
      },
      closed: "Cerrado"
    },
    
    // Reviews
    reviews: {
      title: "Reseñas de Google",
      subtitle: "Lo que dicen nuestros clientes sobre la experiencia Yamauchi",
      reviewsOn: "reseñas en Google",
      leaveReview: "Dejar Reseña en Google",
      likedVisit: "¿Te gustó tu visita?",
      helpOthers: "Déjanos una reseña en Google Maps y ayuda a otros a descubrir el mejor ramen de la montaña",
      menjinThanks: "¡Menjin aprecia tu opinión!",
      errorLoading: "Error al cargar las reseñas",
      noReviews: "No hay reseñas disponibles"
    },
    
    // Footer
    footer: {
      tagline: "El único restaurante especializado en ramen de montaña en Puerto Rico. Fusionando tradición japonesa con sabor boricua.",
      navigation: "Navegación",
      programs: "Programas",
      community: "Comunidad",
      menjinSpirit: "El espíritu del ramen de montaña",
      rights: "Todos los derechos reservados",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      seoKeywords: "yamauchi • ramen • el mejor ramen de la montaña • homemade noodles • japonés • montaña • sodas japonesas • Puerto Rico • Cayey",
      navItems: {
        inicio: "Inicio",
        nosotros: "Nosotros",
        menu: "Menú",
        galeria: "Galería",
        reviews: "Reseñas"
      }
    },
    
    // Gallery Modal
    gallery: {
      title: "Galería & El Arte del Ramen",
      subtitle: "Explora nuestra cocina y ambiente",
      videoTitle: "El Arte del Ramen",
      videoDescription: "Descubre el proceso artesanal detrás de cada bowl de Yamauchi",
      photosTitle: "Galería de Fotos",
      photosSubtitle: "Momentos especiales en Yamauchi Ramen",
      viewImage: "Ver Imagen",
      close: "Cerrar Galería",
      videoNotSupported: "Tu navegador no soporta el elemento de video."
    },
    
    // Affiliate Modal
    affiliate: {
      title: "Programa de Afiliados",
      subtitle: "Únete a nuestra familia",
      whatWeOffer: "Lo que ofrecemos:",
      joinProgram: "¡Únete al Programa!",
      joinDescription: "¿Listo para ser parte de la familia Yamauchi? Contáctanos directamente por Instagram para comenzar tu aventura con nosotros.",
      contactInstagram: "Contáctanos en Instagram",
      sendMessage: "💬 Envíanos un mensaje directo con tu propuesta y contenido",
      close: "Cerrar"
    },
    
    // Collaborators Modal
    collaborators: {
      title: "Colaboradores",
      subtitle: "Arte, comunidad y cultura en la montaña.",
      viewProfile: "Ver perfil →",
      back: "← Volver",
      bio: "Bio",
      collaboration: "Colaboración con Yamauchi",
      contact: "Contacto",
      watchVideo: "Ver video de la colaboración",
      documentation: "Documentación en TikTok"
    }
  },
  
  en: {
    // Header
    nav: {
      inicio: "Home",
      nosotros: "About",
      menu: "Menu",
      ubicacion: "Location",
      galeria: "Gallery",
      afiliados: "Affiliates",
      colaboradores: "Collaborators"
    },
    
    // Hero
    hero: {
      subtitle: "The Spirit of Ramen",
      title: "YAMAUCHI",
      mainTitle: "The best ramen",
      mainTitleHighlight: "in the mountains",
      description: "Inspired by Japanese cuisine with a Puerto Rican touch.",
      descriptionHighlight: "Discover the flavor and freshness found only in the mountains.",
      explorarMenu: "Explore Menu",
      verGaleria: "View Gallery & Video",
      programaAfiliados: "Affiliate Program",
      colaboradores: "Collaborators",
      eyebrow: "Menjin · The Spirit of Ramen",
      verNovedades: "See What's New",
      ordenar: "Order",
      badge: "Handcrafted · Since 2024",
      stats: {
        oneValue: "100%",
        oneLabel: "Handcrafted",
        twoValue: "Thu—Sun",
        twoLabel: "Open",
        threeValue: "Cayey,",
        threeLabel: "Puerto Rico"
      }
    },

    // Sections / Eyebrows
    sections: {
      pillarsEyebrow: "Philosophy",
      pillarsTitle: "What makes us unique",
      pillarsSubtitle: "Three pillars that define every bowl, every glass and every experience at Yamauchi.",
      trendingEyebrow: "What's New",
      trendingTitlePre: "What's ",
      trendingTitleHighlight: "trending",
      trendingDesc: "Discover the creations winning over our community this season.",
      communityEyebrow: "Community",
      communityTitle: "More than a restaurant",
      communitySubtitle: "We are a community that celebrates nature, culture and mountain ramen."
    },

    // Community Actions
    community: {
      affiliateTitle: "Affiliate Program",
      affiliateDesc: "Are you a content creator exploring Puerto Rico's mountains? Join Menjin and receive free ramen in exchange for your authentic content.",
      collabTitle: "Collaborators",
      collabDesc: "Meet the artists, producers and brands who share our vision of blending Japanese culture with the Puerto Rican soul.",
      galleryTitle: "Gallery & Videos",
      galleryDesc: "Feel the Yamauchi experience before you arrive. Photos of the space, the artisanal process and our community's best moments.",
      explore: "Explore"
    },

    // Reviews invitation
    reviewsInvite: {
      text: "We're still gathering our first Google reviews. If you've already visited us, your feedback helps us keep growing."
    },

    aboutBtn: "Learn More",
    contactLabel: "Contact",
    
    // Trending
    trending: {
      title: "Trending",
      subtitle: "Most popular at Yamauchi"
    },
    
    // About
    about: {
      title: "Our Story",
      subtitle: "Japanese tradition in the heart of Puerto Rico",
      features: {
        noodles: {
          title: "Homemade Noodles",
          description: "Prepared daily with traditional Japanese techniques"
        },
        chicken: {
          title: "Sous Vide Chicken",
          description: "Perfect low-temperature cooking for maximum flavor"
        },
        ingredients: {
          title: "Premium Ingredients",
          description: "Selected from the best local and Japanese sources"
        }
      }
    },
    
    // Menu
    menu: {
      title: "Our Menu",
      subtitle: "Discover our main dishes, crafted with love and the finest Japanese techniques",
      verMenu: "View Menu",
      expand: "View full menu",
      collapse: "Show less",
      todos: "All",
      menjinApproves: "Menjin approves every dish with his seal of quality!",
      categories: {
        ramen: "Ramen",
        ramenEspecialidad: "Specialty Ramen",
        combos: "Combos",
        aperitivos: "Appetizers",
        donburi: "Donburi",
        postre: "Dessert",
        bebidas: "Drinks"
      }
    },
    
    // Location
    location: {
      title: "Location & Hours",
      subtitle: "Visit us in the beautiful mountains of Cayey, Puerto Rico",
      address: "Address",
      viewOnMaps: "View on Google Maps",
      hours: "Hours",
      orderOnline: "Order Online",
      callDirect: "Call Direct",
      followUs: "Follow Us on Social Media",
      shareExperience: "Share your experience with #YamauchiRamen!",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
      },
      closed: "Closed"
    },
    
    // Reviews
    reviews: {
      title: "Google Reviews",
      subtitle: "What our customers say about the Yamauchi experience",
      reviewsOn: "reviews on Google",
      leaveReview: "Leave a Review on Google",
      likedVisit: "Did you enjoy your visit?",
      helpOthers: "Leave us a review on Google Maps and help others discover the best ramen in the mountains",
      menjinThanks: "Menjin appreciates your feedback!",
      errorLoading: "Error loading reviews",
      noReviews: "No reviews available"
    },
    
    // Footer
    footer: {
      tagline: "The only restaurant specializing in mountain ramen in Puerto Rico. Fusing Japanese tradition with Puerto Rican flavor.",
      navigation: "Navigation",
      programs: "Programs",
      community: "Community",
      menjinSpirit: "The spirit of mountain ramen",
      rights: "All rights reserved",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      seoKeywords: "yamauchi • ramen • best mountain ramen • homemade noodles • japanese • mountain • japanese sodas • Puerto Rico • Cayey",
      navItems: {
        inicio: "Home",
        nosotros: "About",
        menu: "Menu",
        galeria: "Gallery",
        reviews: "Reviews"
      }
    },
    
    // Gallery Modal
    gallery: {
      title: "Gallery & The Art of Ramen",
      subtitle: "Explore our kitchen and atmosphere",
      videoTitle: "The Art of Ramen",
      videoDescription: "Discover the artisanal process behind every Yamauchi bowl",
      photosTitle: "Photo Gallery",
      photosSubtitle: "Special moments at Yamauchi Ramen",
      viewImage: "View Image",
      close: "Close Gallery",
      videoNotSupported: "Your browser does not support the video element."
    },
    
    // Affiliate Modal
    affiliate: {
      title: "Affiliate Program",
      subtitle: "Join our family",
      whatWeOffer: "What we offer:",
      joinProgram: "Join the Program!",
      joinDescription: "Ready to be part of the Yamauchi family? Contact us directly on Instagram to start your adventure with us.",
      contactInstagram: "Contact us on Instagram",
      sendMessage: "💬 Send us a direct message with your proposal and content",
      close: "Close"
    },
    
    // Collaborators Modal
    collaborators: {
      title: "Collaborators",
      subtitle: "Art, community and culture in the mountains.",
      viewProfile: "View profile →",
      back: "← Back",
      bio: "Bio",
      collaboration: "Collaboration with Yamauchi",
      contact: "Contact",
      watchVideo: "Watch collaboration video",
      documentation: "TikTok Documentation"
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
